<template>
  <div class="template CommonWords">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="allOpen()">{{openTxt}}</el-button>
        <el-button type="primary" @click="commonDirectoryPop()">{{$t('im.commonWords.addCommonWordsList')}}</el-button>
        <el-button type="primary" @click="commonPop()">{{$t('im.commonWords.addCommonWords')}}</el-button>
        <el-button type="primary" @click="importPop()">{{$t('im.commonWords.importAll')}}</el-button>
      </el-form-item>
    </el-form>
    <el-tabs type="border-card" v-model="businessGroupCodeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,businessIndex) in businessGroupData" :name="item.code">
        <span slot="label">{{item.name}}</span>
        <div v-if="treeIndex==businessIndex">
          <el-form :inline="true">
            <el-form-item :label="$t('im.common.locale')" v-if="langList&&langList.length>0">
              <el-select v-model="langId" :placeholder="$t('im.common.placeholderLanguage')" @change="changeLang">
                <el-option
                  v-for="item in langList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="checkAllTree">{{$t('im.bt.allSelect')}}</el-button>
            <el-button type="primary" @click="deletePop">{{$t('im.bt.delete')}}</el-button>
          </el-form>
          <el-collapse v-model="treeValue" @change="aloneOpen" v-if="treeData&&treeData.length>0" accordion>
            <el-collapse-item :name="itemTree.id" v-for="(itemTree,index) in treeData" :disabled="isDisabled(itemTree.conCommonMessageVos)">
              <template slot="title">
                <img @click="editCommon(3,itemTree)" class="picStyle" src="@/assets/IM/edit.png"/>
                <em @click="checkFirstTree(itemTree,index)" class="delCon firstTree" ref="firstTree" :name="itemTree.id"></em>
                {{itemTree.name}}
              </template>
              <div class="titleName" v-for="(childItem,childIndex) in itemTree.conCommonMessageVos">
                <el-tooltip effect="dark" :content="childItem.message" :disabled="isDisabled(childItem.message)" placement="top-start">
                  <el-button>
                    <p class="childName">
                      <img @click="editCommon(1,childItem,itemTree.id)" class="picStyle" src="@/assets/IM/edit.png"/>
                      <em @click="checkSecTree(childItem)" class="delCon secondTree" :id="childItem.id" :name="childItem.id"></em>
                      {{childItem.name}}
                    </p>
                  </el-button>
                </el-tooltip>
                <!--<p class="childName">
                  <img @click="editCommon(1,childItem,itemTree.id)" class="picStyle" src="@/assets/IM/edit.png"/>
                  <em @click="checkSecTree(childItem)" class="delCon secondTree" :id="childItem.id" :name="childItem.id"></em>
                  {{childItem.name}}
                </p>
                <div class="titleCon" v-if="childItem.message">
                  <p>{{childItem.message}}</p>
                  <em v-if="util.isNotEmpty(childItem.message)"></em>
                </div>-->
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="block flexEnd" v-if="totalNum>0">
            <el-pagination
              background
              @size-change="pageSizeChange"
              @current-change="currentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="titleDirectory" :visible.sync="isToOftenDirectoryPop">
      <el-form class="div_form" label-width="100px">
        <el-form-item :label="$t('im.common.bizCodeName')">
          <el-select v-model="businessGroupCodeDirectory" :placeholder="$t('im.common.placeholderBizCodeName')" :disabled="isDisabled(oftenType)">
            <el-option v-for="item in businessGroupData" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.common.locale')" v-if="langList&&langList.length>0">
          <el-select v-model="langIdTcDirectory" :placeholder="$t('im.common.placeholderLanguage')" :disabled="isDisabled(oftenType)">
            <el-option v-for="item in langList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.commonWords.commonWordsList')">
          <el-input type="textarea" :rows="2" v-model="directoryTxt"></el-input>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" @click="submitDirectory">{{$t('im.bt.definite')}}</el-button>
        <el-button @click="isToOftenDirectoryPop=false">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="isToOftenPop">
      <el-form class="div_form" label-width="100px">
        <el-form-item :label="$t('im.common.bizCodeName')">
          <el-select v-model="businessGroupCode" :placeholder="$t('im.common.placeholderBizCodeName')" @change="changeTcBusinessGroup" :disabled="isDisabled(oftenType)">
            <el-option v-for="item in businessGroupData" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.common.locale')" v-if="langList&&langList.length>0">
          <el-select v-model="langIdTc" :placeholder="$t('im.common.placeholderLanguage')" @change="changeTcLang" :disabled="isDisabled(oftenType)">
            <el-option v-for="item in langList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.commonWords.commonWordsList')" v-if="directoryList.length > 0">
          <el-select v-model="directoryID" :placeholder="$t('im.commonWords.placeholderCommonWordsList')" :disabled="isDisabled(oftenType)">
            <el-option
              v-for="item in directoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('im.common.title')">
          <el-input v-model="titleTxt"></el-input>
        </el-form-item>
        <el-form-item :label="$t('im.commonWords.contentTxt')">
          <el-input type="textarea" :rows="5" v-model="contentTxt"></el-input>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" @click="submitOften">{{$t('im.bt.definite')}}</el-button>
        <el-button @click="isToOftenPop=false">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('im.commonWords.importAll')" :visible.sync="exportsVisible" :before-close="closePop">
      <el-upload ref="upload" drag
                 :limit=limitNum
                 :auto-upload="false"
                 accept=".xlsx"
                 :action="UploadUrl()"
                 :before-upload="beforeUploadFile"
                 :on-change="fileChange"
                 :on-exceed="exceedFile"
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">{{$t('im.upload.uploadTipPrefix')}}<em>{{$t('im.upload.uploadTipSuffix')}}</em></div>
        <div class="el-upload__tip" slot="tip">{{$t('im.upload.uploadNumTip')}}</div>
      </el-upload>
      <br/>
      <a href="https://sc.tfejy.com/source/IM/常用语导入模板.xlsx"
         class="el-button el-button--success el-button--default is-plain">{{$t('im.bt.downModel')}}</a>
      <el-button size="small" type="primary" @click="uploadFile">{{$t('im.bt.uploadNow')}}</el-button>
    </el-dialog>
  </div>
</template>

<script>
  require('@/styles/IM/template.css')
  import { localRead, localSave, getQueryString } from '@/utils/tools'
  import apiDeployManagement from '@/api/im/deployManagement'
  import Util from '@/utils/IM/tradeDataUtil'
  import originAxios from 'axios'
  import { getToken } from '@/utils/auth'
  import URL from '@/api/im/url'

  export default {
    name: 'CommonWords',
    props:['messageType','username'],
    data() {
      return {
        util: Util,
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        exportsVisible: false,
        limitNum: 1,  // 上传excell时，同时允许上传的最大数
        fileList: [],   // excel文件列表
        isTalkList: false,  //是否显示删除修改复制框
        clientX: '',//删除修改复制框左右距离
        CommonWordsList: '',//公共常用语列表
        CommonWordsTrees: '',//公共常用语树列表
        isOpen: false,//是都全部展开
        openTxt: window.$t('im.bt.allOpen'),
        treeData: [],//公共常用语树
        treeValue: [],
        treeIndex: 0,
        isToOftenDirectoryPop: false, //新增常用语目录弹窗是否显示
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        langId: 'zh_CN',  //默认tab弹窗显示语言的ID
        langIdTcDirectory: 'zh_CN',  //默认常用语目录弹窗显示语言的ID
        langIdTc: 'zh_CN',  //默认常用语弹窗显示语言的ID
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCodeDirectory: '',  //常用语目录业务编码Code
        businessGroupCodeTab: '',  //tab业务编码Code
        businessGroupCode: '',  //常用语业务编码Code
        isToOftenPop: false, //新增常用语弹窗是否显示
        oftenType: 0, //是否编辑常用语/常用语目录(0：新增常用语；1：编辑常用语；2：新增常用语目录；3：编辑常用语目录；)
        directoryList: [],  //常用语目录
        directoryID: '', //常用语目录ID
        directoryTxt: '',  //常用语目录
        titleTxt: '',  //常用语标题
        contentTxt: '',  //常用语内容
        titleDirectory: window.$t('im.commonWords.addCommonWordsList'),
        title: window.$t('im.commonWords.addCommonWords'),
        editData: '',  //编辑常用语
        treeFirstChecked:[],//选择的常用语目录数组
        treeSecChecked:[],//选择的常用语数组
        currentPage: 1,  //常用语当前页数
        pageSize:10, //当前页条数数
        totalNum: 0,  //常用语当前资源条数
      }
    },
    methods: {
      /*刷选公共常用语树*/
      brushTree(data) {
        let flag = false
        for (const i in data) {
          if (i == this.businessGroupCodeTab) {
            for (const j in data[i]) {
              if (j == this.langId) {
                flag = true
                this.treeData = data[this.businessGroupCodeTab][this.langId]
              }
            }
          }
        }
        if (!flag) this.treeData = ''
      },
      /*业务组tab*/
      changeTab(tab) {
        this.treeIndex = tab.index
        this.businessGroupCodeTab = tab.name
        this.businessGroupCodeDirectory = tab.name
        this.businessGroupCode = tab.name
        // this.brushTree(this.CommonWordsTrees)
        this.openTxt = window.$t('im.bt.allOpen')
        this.isOpen = false
        this.treeValue = [];
        this.initCommonMessageVoTrees()
      },
      /*初始化业务组tab*/
      initTcBusinessGroup() {
        if (this.businessGroupData.length > 0) {
          this.businessGroupCodeDirectory = this.businessGroupData[0].code
          this.businessGroupCodeTab = this.businessGroupData[0].code
          this.businessGroupCode = this.businessGroupData[0].code
        }
      },
      isDisabled(data) {
        let disabled
        if (Util.isEmpty(data) || data == 3 || data == 1) return disabled = 'disabled'
      },
      /*常用语目录选择*/
      aloneOpen(val) {
        if (Util.isEmpty(this.treeValue)) {
          this.isOpen = false
          this.openTxt = window.$t('im.bt.allOpen')
        }else {
          this.isOpen = true
          this.openTxt = window.$t('im.bt.allClose')
        }
      },
      /*常用语选择全部*/
      allOpen() {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          this.openTxt = window.$t('im.bt.allClose')
          this.treeValue = []
          for (let i in this.treeData) {
            this.treeValue.push(this.treeData[i].id)
          }
        } else {
          this.treeValue = []
          this.openTxt = window.$t('im.bt.allOpen')
        }
      },
      /*刷选常用语目录*/
      brushDirectoryList(data) {
        let newData = []
        for (const i in data) {
          if (data[i].bizCode == this.businessGroupCode && data[i].locale == this.langIdTc) {
            if (data[i].nodeType == 0) newData.push(data[i])
          }
        }
        this.directoryList = newData
        if (this.directoryList.length > 0) {
          this.directoryID = this.directoryList[0].id
        } else {
          this.directoryID = ''
        }
      },
      /*选择弹窗业务编码*/
      changeTcBusinessGroup(val) {
        this.directoryID = ''
        let newData = []
        for (const i in this.CommonWordsList) {
          if (this.CommonWordsList[i].bizCode == val && this.CommonWordsList[i].locale == this.langIdTc) {
            if (this.CommonWordsList[i].nodeType == 0) newData.push(this.CommonWordsList[i])
          }
        }
        this.brushDirectoryList(this.CommonWordsList)
      },
      /*选择语言*/
      changeLang(val) {
        // this.brushTree(this.CommonWordsTrees)
        this.openTxt = window.$t('im.bt.allOpen')
        this.isOpen = false
        this.treeValue = []
        this.initCommonMessageVoTrees()
      },
      /*选择弹窗语言*/
      changeTcLang(val) {
        this.brushDirectoryList(this.CommonWordsList)
      },
      /*新建常用语目录弹窗*/
      commonDirectoryPop() {
        this.isToOftenDirectoryPop = true
        this.oftenType = 2
      },
      /*新建常用语弹窗*/
      commonPop() {
        this.isToOftenPop = true
        this.oftenType = 0
        this.title = window.$t('im.commonWords.addCommonWords')
        this.titleTxt = ''
        this.contentTxt = ''
        this.brushDirectoryList(this.CommonWordsList)
      },
      importPop() {
        this.exportsVisible = true
        this.fileList = []
      },
      /*编辑数据*/
      editCommon(type, data, id) {
        this.oftenType = type
        if (type == 1) {
          this.isToOftenPop = true
          this.title = window.$t('im.commonWords.updateCommonWords')
          this.directoryID = id
          this.editData = data
          this.businessGroupCode = this.businessGroupCodeTab
          this.langIdTc = this.langId
          this.titleTxt = data.name
          this.contentTxt = data.message
          let newData = [];
          for (const i in this.CommonWordsList) {
            if (this.CommonWordsList[i].bizCode == this.businessGroupCode && this.CommonWordsList[i].locale == this.langIdTc) {
              if (this.CommonWordsList[i].nodeType == 0) {
                newData.push(this.CommonWordsList[i])
              }
            }
          }
          this.directoryList = newData
          for (const i in this.treeData) {
            if (this.treeData[i].id == this.treeValue) {
              this.directoryID = this.treeData[i].id
            }
          }
        } else if (type == 3) {
          this.isToOftenDirectoryPop = true
          this.titleDirectory = window.$t('im.commonWords.updateCommonWordsList')
          this.directoryID = data.id
          this.businessGroupCodeDirectory = this.businessGroupCodeTab
          this.langIdTcDirectory = this.langId
          for (const i in this.treeData) {
            if (this.treeData[i].id == data.id) {
              this.directoryTxt = this.treeData[i].name
              this.directoryID = this.treeData[i].id
            }
          }
        }
      },
      /*全选删除常用语目录和常用语*/
      checkAllTree(){
        for (const i in this.treeData){
          if (this.$refs.firstTree[i].className == 'delCon firstTree') {
            this.$refs.firstTree[i].className = 'delCon firstTree checked'
            for (const j in this.treeData[i].conCommonMessageVos) {
              document.getElementById(this.treeData[i].conCommonMessageVos[j].id).className = 'delCon secondTree checked'
            }
          } else {
            this.$refs.firstTree[i].className = 'delCon firstTree'
            for (const j in this.treeData[i].conCommonMessageVos) {
              document.getElementById(this.treeData[i].conCommonMessageVos[j].id).className = 'delCon secondTree'
            }
          }
        }
        let checkID = []
        for (const i in document.querySelectorAll('.delCon.firstTree.checked')) {
          if (!isNaN(i)) {
            let name = document.querySelectorAll('.delCon.firstTree.checked')[i].attributes[0].value
            for (const j in this.treeData) {
              if (this.treeData[j].id.toString() == name) {
                checkID.push(this.treeData[j].id)
              }
            }
          }
        }
        this.treeFirstChecked = checkID
      },
      /*选择常用语目录选项*/
      checkFirstTree(obj, indx) {
        if (this.$refs.firstTree[indx].className == 'delCon firstTree') {
          this.$refs.firstTree[indx].className = 'delCon firstTree checked'
          for (const i in obj.conCommonMessageVos) {
            document.getElementById(obj.conCommonMessageVos[i].id).className = 'delCon secondTree checked'
          }
        } else {
          this.$refs.firstTree[indx].className = 'delCon firstTree'
          for (const i in obj.conCommonMessageVos) {
            document.getElementById(obj.conCommonMessageVos[i].id).className = 'delCon secondTree'
          }
        }
        let checkID = []
        for (const i in document.querySelectorAll('.delCon.firstTree.checked')) {
          if (!isNaN(i)) {
            let name = document.querySelectorAll('.delCon.firstTree.checked')[i].attributes[0].value
            for (const j in this.treeData) {
              if (this.treeData[j].id.toString() == name) {
                checkID.push(this.treeData[j].id)
              }
            }
          }
        }
        this.treeFirstChecked = checkID
      },
      /*选择常用语选项*/
      checkSecTree(obj) {
        if (document.getElementById(obj.id).className == 'delCon secondTree') {
          document.getElementById(obj.id).className = 'delCon secondTree checked'
        } else {
          document.getElementById(obj.id).className = 'delCon secondTree'
        }
        let checkID = []
        for (const i in document.querySelectorAll('.delCon.secondTree.checked')) {
          if (!isNaN(i)) {
            let name = document.querySelectorAll('.delCon.secondTree.checked')[i].attributes[0].value;
            for (const k in this.treeData){
              for (const j in this.treeData[k].conCommonMessageVos) {
                if (this.treeData[k].conCommonMessageVos[j].id.toString() == name) {
                  checkID.push(this.treeData[k].conCommonMessageVos[j].id)
                }
              }
            }
          }
        }
        this.treeSecChecked = checkID
      },
      /*删除数据弹窗*/
      deletePop(){
        if (this.treeFirstChecked.length > 0 || this.treeSecChecked.length > 0) {
          this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
            confirmButtonText: window.$t('im.bt.definite'),
            cancelButtonText: window.$t('im.bt.cancel'),
            type: 'warning',
            center: true
          }).then(() => {
            this.deleteMessage();
          }).catch(() => {
            this.$message.info(window.$t('im.common.cancelDel'))
          })
        }else this.$message.info(window.$t('im.commonWords.checkDel'))
      },
      /*删除数据*/
      deleteMessage() {
        let data = {
          ids: this.treeFirstChecked.concat(this.treeSecChecked).join(",")
        }
        apiDeployManagement.deleteBatchRecursiveConCommonMessage(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            this.initCommonMessageVoTrees()
            for (const i in this.treeData) {
              this.$refs.firstTree[i].className = 'delCon firstTree'
              for (const j in this.treeData[i].conCommonMessageVos) {
                document.getElementById(this.treeData[i].conCommonMessageVos[j].id).className = 'delCon secondTree'
              }
            }
          } else {
            this.$message.error(window.$t('im.common.delFail'))
          }
        })
      },
      /*初始化公共常用语列表*/
      initCommonMessageList() {
        let data = {
          companyId: this.userInfo.companyId,
          messageType: this.messageType,
          username:this.username,
          pid:0
        }
        apiDeployManagement.queryConCommonMessageList(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.CommonWordsList = res.result
              this.brushDirectoryList(res.result)
            }
          }
        })
      },
      /*初始化公共常用语树形*/
      initCommonMessageVoTrees() {
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCodeTab,
          locale: this.langId,
          messageType: this.messageType,
          username:this.username,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }
        this.getCommonMessageVoTrees(data)
      },
      /*获取公共常用语树形数据*/
      getCommonMessageVoTrees(data){
        apiDeployManagement.queryConCommonMessageVoTreePage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              if (res.result.list && res.result.list.length > 0) {
                this.treeData = res.result.list
              } else {
                this.treeData = ''
              }
              this.totalNum = res.result.total
              // this.brushTree(this.CommonWordsTrees)
            }
          }
        })
      },
      /*切换分页条数*/
      pageSizeChange(val){
        this.pageSize = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          messageType: this.messageType,
          username:this.username,
          pageNum: this.currentPage,
          pageSize: val,
        }
        this.getCommonMessageVoTrees(data)
      },
      /*切换历史会话当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          messageType: this.messageType,
          username:this.username,
          pageNum: val,
          pageSize: this.pageSize,
        }
        this.getCommonMessageVoTrees(data)
      },
      /*新增常用语目录*/
      addCommonDirectoryMessage(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          locale: this.langIdTcDirectory,
          messageType: this.messageType,
          nodeType: 0,
          name: this.directoryTxt,
          username:this.username,
        }
        apiDeployManagement.addConCommonDirectory(data).then(res => {
          if (res.code == 0) {
            this.isToOftenDirectoryPop = false
            this.initCommonMessageList()
            this.initCommonMessageVoTrees()
          }
        })
      },
      /*确认常用语目录*/
      submitDirectory() {
        if (Util.isNotEmpty(this.directoryTxt.replace(/\s/g, ''))) {
          if (this.oftenType == 2) {
            this.addCommonDirectoryMessage()
          } else if (this.oftenType == 3) {
            let data = {
              operator: this.userInfo.id,
              operatorName: this.userInfo.displayName,
              bizCode: this.businessGroupCode,
              companyId: this.userInfo.companyId,
              locale: this.langIdTcDirectory,
              messageType: this.messageType,
              nodeType: 0,
              name: this.directoryTxt,
              id: this.directoryID,
              username:this.username,
            }
            this.updateCommonMessage(data)
          }
        } else this.$message.error(window.$t('im.commonWords.notCommonWordsList'));
      },
      /*新增常用语*/
      addCommonMessage(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          bizCode: this.businessGroupCode,
          companyId: this.userInfo.companyId,
          locale: this.langIdTc,
          messageType: this.messageType,
          nodeType: 1,
          pid: this.directoryID,
          name: this.titleTxt,
          message: this.contentTxt,
          username:this.username,
        }
        apiDeployManagement.addConCommonMessage(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initCommonMessageVoTrees()
          }
        })
      },
      /*编辑常用语*/
      updateCommonMessage(data) {
        apiDeployManagement.updateConCommonMessage(data).then(res => {
          if (res.code == 0) {
            if (this.oftenType == 1) {
              this.isToOftenPop = false
            } else if (this.oftenType == 3) {
              this.isToOftenDirectoryPop = false
            }
            this.initCommonMessageVoTrees()
          }
        })
      },
      /*确认常用语*/
      submitOften() {
        if (this.directoryList.length>0){
          if (Util.isNotEmpty(this.titleTxt.replace(/\s/g, ''))) {
            if (this.oftenType == 0) {
              this.addCommonMessage()
            } else if (this.oftenType == 1) {
              let data = {
                operator: this.userInfo.id,
                operatorName: this.userInfo.displayName,
                bizCode: this.businessGroupCode,
                companyId: this.userInfo.companyId,
                locale: this.langIdTc,
                messageType: this.messageType,
                nodeType: 1,
                pid: this.directoryID,
                name: this.titleTxt,
                message: this.contentTxt,
                id: this.editData.id,
                username:this.username,
              }
              this.updateCommonMessage(data)
            }
          } else this.$message.error(window.$t('im.commonWords.notTitle'));
        } else this.$message.error(window.$t('im.commonWords.notCommonWordsList1'));
      },
      // 文件超出个数限制时的钩子
      exceedFile(files, fileList) {
        this.$message.warning(window.$t('im.upload.numPrefix') + this.limitNum + window.$t('im.upload.numMid') + files.length + fileList.length + window.$t('im.upload.numSuffix'))
      },
      // 文件状态改变时的钩子
      fileChange(file, fileList) {
        this.fileList.push(file.raw)
      },
      // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
      beforeUploadFile(file) {
        let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        let size = file.size / 1024 / 1024
        if (extension !== 'xlsx') {
          this.$message.warning(window.$t('im.upload.excelTipOne'))
        }
        if (size > 10) {
          this.$message.warning(window.$t('im.upload.excelTipTwo'))
        }
      },
      // 文件上传成功时的钩子
      handleSuccess(res, file, fileList) {
        this.fileList = []
        this.$message.success(window.$t('im.upload.success'))
      },
      // 文件上传失败时的钩子
      handleError(err, file, fileList) {
        this.$message.error(window.$t('im.upload.fail'))
      },
      UploadUrl: function() {
        // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
        return ''
      },
      uploadFile() {
        if (this.fileList.length === 0) {
          this.$message.warning(window.$t('im.upload.pleaseUpload'))
        } else {
          let form = new FormData()
          let fileObj = this.fileList[0]
          form.append('file', fileObj)
          form.append(`companyId`, this.userInfo.companyId)
          form.append("messageType", this.messageType)
          if (this.messageType == 1) {
            form.append('username', this.userInfo.userName)
          }
          form.append(`operator`, this.userInfo.id)
          form.append(`operatorName`, this.userInfo.displayName)
          originAxios.post(URL.serviceWelcomeMessage.importCoverCommonMessage, form, {
            headers: {
              'Authorization': getToken(getQueryString('label')),
              'Content-Type': 'multipart/form-data'
            },
            timeout: 30000
          }).then(
            res => {
              if (res.data.code == 0) {
                this.$message.success(window.$t('im.upload.success'))
                this.fileList = []
                this.isToOftenDirectoryPop = false
                this.initCommonMessageList()
                this.initCommonMessageVoTrees()
              } else {
                this.$message.error(window.$t('im.upload.fail'))
              }
            }, err => {
              this.$message.error(window.$t('im.upload.fail'))
            })
        }
      }, /*关闭弹窗*/
      closePop() {
        this.exportsVisible = false
        this.fileList = []
        this.$refs.upload.clearFiles()
      }
    },
    mounted() {
      this.initTcBusinessGroup()
      this.initCommonMessageList()
      this.initCommonMessageVoTrees()
    }
  }
</script>

<style>
  .CommonWords .el-collapse-item__content{position: relative}
  .CommonWords .el-tabs__content,.CommonWords .el-collapse-item__wrap{overflow: initial}
  .CommonWords .div_form .el-select{width: 100%}
  .CommonWords .el-collapse-item.is-disabled .el-collapse-item__header{color: #333}
  .CommonWords .el-collapse-item.is-disabled .el-collapse-item__header .el-collapse-item__arrow{display: none}
  .CommonWords .titleName {
    position: relative;
    cursor: pointer;
    padding-left: 10px;
  }
  .CommonWords .titleName p{display: inline-block;}
  .CommonWords .titleName .titleCon{
    display: none;
    position: absolute;
    left: 45px;
    top: -45px;
  }
  .CommonWords .titleName .titleCon p{
    border-radius: 4px;
    padding: 10px;
    z-index: 2000;
    font-size: 12px;
    line-height: 1.2;
    min-width: 28px;
    word-wrap: break-word;
    background: #303133;
    color: #FFF;
  }
  .CommonWords .titleName .titleCon em{
    display: block;
    position: absolute;
    left: 8px;
    top: 34px;
    width: 0;
    height: 0;
    border-top: 8px solid #303133;
    border-right: 6px solid rgba(0,0,0,0);
    border-bottom: 8px solid rgba(0,0,0,0);
    border-left: 6px solid rgba(0,0,0,0);
  }
  .CommonWords .titleName:hover .titleCon{display: block}
  .CommonWords .titleName .el-button{
    border: none;
    padding: 0;
  }
  .CommonWords .titleName .el-button:focus,.CommonWords .titleName  .el-button:hover{
    background: #fff;
    color: #606266;
  }
  .CommonWords .titleName .childName{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  .CommonWords .picStyle{width: 16px;margin-right: 5px}
  .CommonWords .delCon{
    overflow: hidden;
    display: inline-block;
    background: url("../../../assets/IM/check_no.png") no-repeat center;
    background-size: 100% 100%;
    width: 19px;
    height: 19px;
    margin: 0 5px 0 0
  }
  .CommonWords .delCon.checked{
    background: url("../../../assets/IM/checked.png") no-repeat center;
    background-size: 100% 100%;
  }
</style>
